import { Navigate, useLocation } from 'react-router-dom';
import { useIsAdmin } from '@/hooks/useIsAdmin';
import { stashAdminReturn } from '@/lib/adminReturn';

interface Props {
  children: React.ReactNode;
}

/**
 * Wraps the backoffice routes (/analytics, /admin/*). Three states:
 *   loading      → spinner
 *   no session   → stash the intended path + go to /login (redeemed post-login in
 *                  OnboardingRouter for admins, so login lands back in the panel)
 *   not an admin → silent redirect home — no "no access" wall (Piotr 2026-07-21:
 *                  don't advertise the panel; the DB layer is locked regardless)
 *   admin        → children
 */
const AdminGate = ({ children }: Props) => {
  const { loading, isAdmin, hasSession } = useIsAdmin();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-primary" />
      </div>
    );
  }

  if (!hasSession) {
    stashAdminReturn(location.pathname + location.search);
    return <Navigate to="/login" replace />;
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default AdminGate;
